
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ProfileForm from '@/components/profile/ProfileForm';
import UserMenu from '@/components/UserMenu';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import { useAuth } from '@/hooks/useAuth';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import { Navigate } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';

const Profile = () => {
  const { user: supabaseUser } = useAuth();
  const { user: internalUser } = useInternalAuth();
  const isMobile = useIsMobile();

  // If no user is logged in, redirect to login
  if (!supabaseUser && !internalUser) {
    return <Navigate to="/login" replace />;
  }

  // If internal user is logged in, redirect to internal dashboard
  if (internalUser && !supabaseUser) {
    return <Navigate to="/internal-dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Show appropriate header based on device */}
      {isMobile ? <MobileHeader /> : <Header />}
      
      <main className={`${
        isMobile 
          ? 'pt-20 pb-20 px-4' 
          : 'pt-28 pb-6 px-4 md:px-6'
      }`}>
        <div className="max-w-6xl mx-auto">
          <ProfileForm />
        </div>
      </main>
      
      {!isMobile && <Footer />}
      <MobileBottomNav />
    </div>
  );
};

export default Profile;
